import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/',
    name: 'RASDashboard',
    component: () => import(/* webpackChunkName: "Rasdashboard" */ '../views/Dashboards/RASDashboard.vue')
  },
  {
    path: '/',
    name: 'ExpenseAllocationDashboard',
    component: () => import(/* webpackChunkName: "ExpenseDashboard" */ '../views/Dashboards/ExpenseAllocationDashboard.vue')
  },
  {
    path: '/',
    name: 'PeriodicReportingDashboard',
    component: () => import(/* webpackChunkName: "PeriodicReportingDashboard" */ '../views/Dashboards/PeriodicReportingDashboard.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue')
  },
  {
    path: '/uploads',
    name: 'UploadManagement',
    component: () => import(/* webpackChunkName: "uploads" */ '../views/System/UploadManagement.vue')
  },
  // {
  //   path: '/expense-allocation/layer-1',
  //   name: 'ExpenseAllocationLayer1',
  //   component: () => import(/* webpackChunkName: "expense-allocation-layer-1" */ '../views/ExpenseAllocation/ExpenseAllocationLayer1.vue')
  // },
  // {
  //   path: '/expense-allocation/layer-2',
  //   name: 'ExpenseAllocationLayer2',
  //   component: () => import(/* webpackChunkName: "expense-allocation-layer-2" */ '../views/ExpenseAllocation/ExpenseAllocationLayer2.vue')
  // },
  // {
  //   path: '/expense-allocation/amortization',
  //   name: 'Amortization',
  //   component: () => import(/* webpackChunkName: "expense-allocation-amortization" */ '../views/ExpenseAllocation/Amortization.vue')
  // },
  // {
  //   path: '/expense-allocation/damc',
  //   name: 'DAMCAllocation',
  //   component: () => import('../views/ExpenseAllocation/DAMC.vue')
  // },
  // {
  //   path: '/expense-allocation/rolling',
  //   name: 'Rolling',
  //   component: () => import('../views/ExpenseAllocation/Rolling.vue')
  // },
  // {
  //   path: '/expense-allocation/defer',
  //   name: 'Defer',
  //   component: () => import('../views/ExpenseAllocation/Defer.vue')
  // },
  // {
  //   path: '/expense-allocation/final',
  //   name: 'FinalAmortization',
  //   component: () => import('../views/ExpenseAllocation/FinalAmortization.vue')
  // },
  {
    path: '/manual-journal',
    name: 'GeneralLedger',
    component: () => import(/* webpackChunkName: "accounting-ledger" */ '../views/Accounting/GeneralLedger.vue')
  },
  {
    path: '/posting-journal',
    name: 'PostingJournal',
    component: () => import(/* webpackChunkName: "posting-journal" */ '../views/Accounting/PostingJournal.vue')
  },
  {
    path: '/accounting/trial-balance',
    name: 'TrialBalance',
    component: () => import(/* webpackChunkName: "trial-balance" */ '../views/Accounting/TrialBalance.vue')
  },
  {
    path: '/downloads',
    name: 'DownloadCenter',
    component: () => import(/* webpackChunkName: "downloads" */ '../views/DownloadCenter.vue')
  },
  {
    path: '/ras-input',
    name: 'RASInput',
    component: () => import(/* webpackChunkName: "ras-input" */ '../views/Input/RASInput.vue')
  },
  {
    path: '/pr-input',
    name: 'PeriodicReportInput',
    component: () => import(/* webpackChunkName: "pr-input" */ '../views/Input/PeriodicReportInput.vue')
  },
  {
    path: '/ar',
    name: 'AnnualReport',
    component: () => import(/* webpackChunkName: "ar-input" */ '../views/AnnualReporting/AnnualReporting.vue')
  },
  {
    path: '/ar-gl',
    name: 'AnnualGL',
    component: () => import(/* webpackChunkName: "ar-input" */ '../views/AnnualReporting/AnnualGL.vue')
  },
  {
    path: '/expense-allocation-input',
    name: 'ExpenseAllocationInput',
    component: () => import(/* webpackChunkName: "expense-allocation-input" */ '../views/Input/ExpenseAllocationInput.vue')
  },
  {
    path: '/ras-output',
    name: 'RASOutput',
    component: () => import(/* webpackChunkName: "ras-output" */ '../views/Output/RASOutput.vue')
  },
  {
    path: '/expense-allocation-output',
    name: 'ExpenseAllocationOutput',
    component: () => import(/* webpackChunkName: "ras-output" */ '../views/Output/ExpenseAllocationOutput.vue')
  },
  {
    path: '/chart-of-accounts',
    name: 'ChartOfAccounts',
    component: () => import(/* webpackChunkName: "chart-of-accounts" */ '../views/System/ChartOfAccounts.vue')
  },
  {
    path: '/audit-logs',
    name: 'AuditLogs',
    component: () => import(/* webpackChunkName: "event-logs" */ '../views/System/AuditLogs.vue')
  },
  {
    path: '/logs',
    name: 'EventLogs',
    component: () => import(/* webpackChunkName: "event-logs" */ '../views/System/EventLogs.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import(/* webpackChunkName: "users" */ '../views/System/Users.vue')
  },
  {
    path: '/fsd',
    name: 'FSD',
    component: () => import(/* webpackChunkName: "fsd" */ '../views/FSDisclosures/FSD.vue')
  },
  // {
  //   path: '/account',
  //   name: 'MyAccount',
  //   component: () => import(/* webpackChunkName: "account" */ '../views/MyAccount.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && localStorage.getItem('token') == null) 
  {
    localStorage.removeItem('OngoingFiles')
    window.location.href = '/login'
  }
  else {
    next()
  }
})

export default router
